import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ApplicationState } from 'store';
import MonitoringSellingPage from 'components/organisms/monitoring_selling_page';
import Monitoring from 'components/organisms/monitoring';
import Loader from 'components/atoms/loader';
import BlockedSubscription from 'components/molecules/blocked_subscription';
import { monitoringSubscriptionCompany } from 'services/monitoring_companies';
import { getServiceSubscriptionStatus } from 'store/modules/service_subscription_store/actions';
import { ProfileState } from 'store/modules/profile_store/types';
import { ServicesSubscriptionState } from 'store/modules/service_subscription_store/types';

const MonitoringService: React.FC = () => {
  const dispatch = useDispatch();

  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);

  const { servicesSubscriptions, request } = useSelector<
    ApplicationState,
    ServicesSubscriptionState
  >((state) => state.storage.servicesSubscriptions);

  const MONITORING_SERVICE_ID = 2;

  // in_trial_period nulo significa "nunca teve trial" — nao pode ser tratado como trial esgotado
  const trialExpired = () => {
    const trial = servicesSubscriptions.Monitoring?.in_trial_period;

    return trial !== null && trial !== undefined && Number(trial) === 0;
  };

  useEffect(() => {
    localStorage.removeItem('redirectAfterLogin');
    dispatch(
      getServiceSubscriptionStatus(MONITORING_SERVICE_ID, monitoringSubscriptionCompany(profile)),
    );
  }, []);

  const renderMonitoringService = () => {
    if (request.loading)
      return (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: '70vh ' }}
        >
          <Loader />
        </div>
      );

    if (servicesSubscriptions.Monitoring?.service_paralyzed) {
      return <BlockedSubscription paralyzed />;
    }
    if (
      !servicesSubscriptions.Monitoring?.current_signature &&
      !servicesSubscriptions.Monitoring?.has_any_signature &&
      !profile.in_sample
    )
      return <MonitoringSellingPage />;

    if (
      servicesSubscriptions.Monitoring?.has_any_signature &&
      !servicesSubscriptions.Monitoring?.current_signature &&
      trialExpired() &&
      !profile.in_sample
    )
      return <BlockedSubscription paralyzed={false} />;

    return <Monitoring />;
  };

  return <div className="page-container">{renderMonitoringService()}</div>;
};

export default MonitoringService;
